/*
 * @Author: 朱占伟
 * @LastEditors: 朱占伟
 * @description: 全局校验规则统一管理
 * @Date: 2021-09-15 18:10:43
 * @LastEditTime: 2021-09-15 18:11:49
 */

//正整数
export const INT = /[1-9]{1}[0-9]*/g